import { NotificationsState } from '@layout/notifications/store/state/notifications.state';

export const notificationsState = [NotificationsState];
